import { formatISOTimeForDisplay } from '@plato/shared-util/time-utils';
import { InfoTag } from '@plato/ui-legacy/components/ui/info-tag';
import Text from '@plato/ui-legacy/components/ui/text';
import { formatShortDate } from '@plato/ui-legacy/lib/date-helpers';
import { useResolvedLocale } from '@plato/ui-legacy/lib/hooks/locale';
import { CalendarIcon, ClockIcon, RefreshCwIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { UpcomingEventsListItem } from '../../../server/types/infer-trpc-types.ts';

type EventTimelineHeaderProps = {
    event: UpcomingEventsListItem;
};

export function EventTimelineHeader({ event }: EventTimelineHeaderProps) {
    const { t } = useTranslation('events');
    const locale = useResolvedLocale();
    const recurrenceWeeksCount = event.recurrenceRule?.weeks ?? 0;

    return (
        <div className="flex justify-between gap-2 w-full flex-col sm:flex-row">
            <span>
                <Text>{t('event')}</Text>
                &nbsp;
                <Text color="neutral-500">
                    {t('scheduled_by_user', { user: event.owner_name, ns: 'common' })}
                </Text>
            </span>
            <div className="flex gap-3 sm:gap-4 flex-wrap">
                <InfoTag icon={CalendarIcon}>{formatShortDate(event.date, locale)}</InfoTag>
                {event.start_time && (
                    <InfoTag icon={ClockIcon}>{formatISOTimeForDisplay(event.start_time)}</InfoTag>
                )}
                {!!recurrenceWeeksCount && (
                    <InfoTag icon={RefreshCwIcon}>
                        {t('card_recurrence_weeks', {
                            count: recurrenceWeeksCount,
                        })}
                    </InfoTag>
                )}
            </div>
        </div>
    );
}
